export default __webpack_public_path__ + "static/media/viber_image_2022-06-04_09-25-58-207.4a6dc69a.jpg";